import useMobileDetector from '@shared/hooks/useMobileDetector';
import { MdcTypography } from 'ids-wc/dist/react/components';

export const PageTitle = (props: { title: string }) => {
  const isMobile = useMobileDetector();
  const { title } = props;

  const variant = isMobile ? 'headline2' : 'headline1';
  return <MdcTypography text={title} variant={variant} color="textPrimary" />;
};
